import React from 'react';
import { FormField, Select } from '../../ui/Form';
import type { AccountingUnit } from '../../../types/accounting-levels';

interface AccountingUnitFormProps {
  unit: Partial<AccountingUnit>;
  existingUnits: AccountingUnit[];
  onChange: (unit: Partial<AccountingUnit>) => void;
}

export function AccountingUnitForm({ unit, existingUnits, onChange }: AccountingUnitFormProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <FormField label="Nom">
        <input
          type="text"
          value={unit.name || ''}
          onChange={(e) => onChange({ ...unit, name: e.target.value })}
          className="form-input"
          placeholder="Nom de l'unité"
        />
      </FormField>

      <FormField label="Code">
        <input
          type="text"
          value={unit.code || ''}
          onChange={(e) => onChange({ ...unit, code: e.target.value })}
          className="form-input"
          placeholder="Code unique"
        />
      </FormField>

      <FormField label="Type d'unité">
        <Select
          value={unit.type}
          onChange={(e) => onChange({ ...unit, type: e.target.value as AccountingUnit['type'] })}
          options={[
            { value: 'company', label: 'Entreprise (Niveau 0)' },
            { value: 'branch', label: 'Succursale (Niveau 1)' },
            { value: 'pos', label: 'Point de vente (Niveau 2)' }
          ]}
        />
      </FormField>

      {unit.type !== 'company' && (
        <FormField label="Rattachement">
          <Select
            value={unit.parentId}
            onChange={(e) => onChange({ ...unit, parentId: e.target.value })}
            options={[
              { value: '', label: 'Sélectionner...' },
              ...existingUnits
                .filter(u => unit.type === 'branch' ? u.type === 'company' : (u.type === 'company' || u.type === 'branch'))
                .map(u => ({ value: u.id, label: `${u.name} (${u.type === 'company' ? 'Entreprise' : 'Succursale'})` }))
            ]}
          />
        </FormField>
      )}
    </div>
  );
}